// extracted by mini-css-extract-plugin
export default {"textBlock":"text-block_textBlock__aCEdz","smallGap":"text-block_smallGap__+i1is","label":"text-block_label__42yaa"};